module.exports = __webpack_public_path__ + "media/images/photo/plans/shooting-spots/shooting-spot-tokai-1-eab1d170dd6c56762f855f5e2d9c1bc3.png";